<template>
  <span></span>
</template>

<script>
export default {
  name: "ShowPopup",
  mounted() {
    const  url = window.location.href;
    if (this.getCookie('seenPopup') || url.includes('sms-donate')) {
      console.log('will not show popup');
    } else {
      this.showPopup();
    }

  },
  methods: {
    getCookie(name) {
        let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) return match[2];
    },
    createCookie(name,value,days) {
      if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        var expires = "; expires="+date.toGMTString();
      }
      else var expires = "";
      document.cookie = name+"="+value+expires+"; path=/";
    },
    showPopup() {
      this.$swal.fire({
        html: `<a href="https://www.charidy.com/dllink"><img style="width: 100%; z-index: 100000" loop src="/images/charidy-banner.png"></a>`,
        width: 600,
        padding: '3em',
        showConfirmButton: false,
        showCancelButton: true,
        background: '000',
        confirmButtonText: 'Donate Now!',
        cancelButtonText: 'Continue To Website'
      }).then( result => {
        console.log(result);
        if (result.isConfirmed) {
          window.location.href = "https://www.charidy.com/dllink";
        } else {
          this.createCookie('seenPopup', '1', 1);
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
